import React, { useEffect, useMemo } from 'react';

import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import { useUnit } from 'effector-react';
import { MRT_ColumnDef, MRT_SortingState } from 'material-react-table';
import moment from 'moment';

import { TableGridLocal } from '../../../../components/TableGridLocal';
import { ClientDetails$, clientDetailsApi } from '../../../../effector/clientDetails';
import { ClientHistory } from '../../../../types/clientDetails';
import { PageParams, SortType } from '../../../../types/pagination';

export const SignalHistory: React.FC<{ agreementId: string; options: (arg: PageParams) => void }> = ({
  agreementId,
  options,
}) => {
  const { history, isHistoryFullHistory } = useUnit(ClientDetails$);
  const isHistoryLoading = useUnit(clientDetailsApi.getHistory.pending);

  useEffect(() => {
    options({
      pageNumber: 0,
      pageSize: 100000,
      sortFieldName: 'datetime',
      sortDirection: SortType.Desk,
    });
  }, [options]);

  const columns = useMemo<MRT_ColumnDef<ClientHistory>[]>(
    () => [
      {
        accessorKey: 'dateTime',
        header: 'Дата и время',
        enableColumnFilter: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const timeFormatted = moment(cell.row.original.dateTime).format('DD.MM.YYYY HH:mm');
          return <span>{timeFormatted}</span>;
        },
      },
      {
        accessorKey: 'client',
        header: 'Клиент',
        enableColumnFilter: false,
        enableColumnActions: false,
        Cell: ({ cell }) => <span dangerouslySetInnerHTML={{ __html: cell.row.original.client }} />,
      },
      {
        accessorKey: 'signals',
        header: 'Сигналы',
        enableColumnFilter: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const { signals, tooltip } = cell.row.original;

          return (
            <Tooltip title={<div dangerouslySetInnerHTML={{ __html: tooltip }} />} arrow placement="top">
              <span dangerouslySetInnerHTML={{ __html: signals }} />
            </Tooltip>
          );
        },
      },
      {
        accessorKey: 'messages',
        header: 'Сообщения',
        enableColumnFilter: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const { signals, messages, tooltip } = cell.row.original;

          if (signals) {
            return <>{messages}</>;
          }

          return (
            <Tooltip title={<div dangerouslySetInnerHTML={{ __html: tooltip }} />} arrow placement="top">
              <span dangerouslySetInnerHTML={{ __html: messages }} />
            </Tooltip>
          );
        },
      },
      {
        accessorKey: 'executions',
        header: 'Выполнение',
        enableColumnFilter: false,
        enableColumnActions: false,
        Cell: ({ cell }) => <span dangerouslySetInnerHTML={{ __html: cell.row.original.executions }} />,
      },
    ],
    [],
  );

  const columnSorts = useMemo<MRT_SortingState>(
    () => [
      {
        desc: true,
        id: 'dateTime',
      },
    ],
    [],
  );

  return (
    <Box sx={{ mt: 2 }}>
      <TableGridLocal
        name="statistic-signal-history"
        columns={columns}
        data={history}
        enablePagination={false}
        columnSorts={columnSorts}
        showColumnDividers
        totalRowCount={history.length}
        bottomToolbarCustomActions={
          !isHistoryFullHistory ? (
            <Button
              variant="contained"
              onClick={() => clientDetailsApi.getHistory({ agreementId, sortType: 'd' })}
              disabled={isHistoryLoading}
              startIcon={isHistoryLoading ? <CircularProgress size={18} color="inherit" /> : undefined}
            >
              {isHistoryLoading ? 'Загрузка…' : 'Далее'}
            </Button>
          ) : undefined
        }
      />
    </Box>
  );
};
